export default {
  viewAccessLogs_description:
    "Permission to see logs of who's been accessing the Insights platform.",
  manageUsers_description:
    'Permission to manage users in the Insights platform.',
  accessApplicantsResults_description: `Gives users access to both "Admissions > Assessment results" and "Admissions > Download assessment results"`,
  takeDuet_description:
    "Gives users the ability to fill in the duet assessment, which helps build the school's profile.",
  viewDuetProfile_description:
    "Gives users ability to see their program's duet profile.",
  passthrough_description:
    'Gives <strong>Analytics</strong> users the ability to pass back to legacy Analytics. This requires the user to have a matching account in legacy Analytics. Required for MSPE access.',
  clinicalGatewayExamsViewer_description:
    'Gives users the ability to see clinical gateway exams data and corresponding dashboards for CCSE and STEP 2 data from NBME.',
  courseEvaluationViewer_description:
    'Gives users the ability to see course evaluation data.',
  examViewer_description:
    'Gives users the ability to see in-house exam data and corresponding dashboards from Examsoft.',
  gradesDataViewer_description:
    'Gives users the ability to see learner grade data and corresponding dashboards/visualizations.',
  studentAssessmentViewer_description:
    'Gives users the ability to see any dashboards/visualizations containing evaluation data where a student/learner is the target.',
  matriculationDataViewer_description:
    'Gives users the ability to see matriculation data and corresponding dashboards/filters about a learner.',
  nbmeSubjectExamsViewer_description:
    'Gives users the ability to see subject exam data from the NBME and corresponding dashboards and visualizations.',
  preclinicalGatewayExamsViewer_description:
    'Gives users the ability to see preclinical gateway exams data and corresponding dashboards like CBSE and STEP 1 from NBME.',
  residencyMatchDataViewer_description:
    'Gives users the ability to see residency match data and corresponding dashboards & visualizations.',
  manageSnapshotReviewers_description:
    'Gives users the ability to assign interviews to reviewers and review all interviews.',
  internal_description:
    'Gives users access to internal (employee-only) dashboards for diagnostic purposes.'
};
